interface IProps {
  buttonText: JSX.Element;
  onClick: () => void;
}

const NavbarWalletButton: React.FC<IProps> = ({
  buttonText,
  onClick
}: IProps) => (
  <button type="button" onClick={onClick} className="navbarWalletButton">
    <div style={{ display: 'flex' }}>Balance: &nbsp; {buttonText}</div>
  </button>
);

export default NavbarWalletButton;
